import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/router/routes';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { useMallScopeStore } from '@/stores/mallScopeStore';
import { useAuthStore } from '@/stores/authStore';

export function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const user = useAuthStore((s) => s.user);

  const syncFromProfile = useMallScopeStore((s) => s.syncFromProfile);

  /*
    AÇILIŞTA SESSİZ OTURUM KURTARMA.

    Erişim token'ı bellekte tutulduğu için sayfa yenilendiğinde kaybolur.
    httpOnly çerezdeki yenileme token'ıyla sessizce yeni bir erişim
    token'ı alınır; kullanıcı her sekme açılışında yeniden giriş yapmak
    zorunda kalmaz.
  */
  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  /*
    AVM LİSTESİ PROFİLDEN GELİR.

    Daha önce sabit bir demo listesinden okunuyordu; kullanıcının gerçekte
    hangi AVM'lere yetkisi olduğu dikkate alınmıyordu. Artık `/auth/me`
    yanıtındaki liste kullanılıyor — yetkisiz bir AVM seçicide hiç
    görünmez.
  */
  useEffect(() => {
    if (!user) {
      syncFromProfile([], false);
      return;
    }

    syncFromProfile(
      user.malls.map((m) => ({
        id: m.id,
        name: m.name,
        city: m.city,
        code: m.code,
        gla: m.gla,
        // Sunucudan sayılarak gelir. Sabit 0 yazıldığında AVM seçici her
        // AVM'yi "0 ünite" diye gösteriyordu — yani boşmuş gibi.
        unitCount: m.unitCount,
      })),
      user.canViewAllMalls,
    );
  }, [user, syncFromProfile]);

  return (
    <QueryProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryProvider>
  );
}
